import { MACRO_ZONE, REGIONI } from '../../../common/utils/geoItalia';
import { REGION_MACRO } from '../italia/regionPaths';

/** Path pubblico del modello Blender (GLB) */
export const ITALIA_GLB_DEFAULT = '/assets/italia/italia-regions.glb';

export const REGION_IDS = REGIONI.map((r) => r.id);

/**
 * Alias accettati per i nomi mesh in Blender → id regione interno.
 * Aggiungi qui varianti se in Blender usi nomi diversi.
 */
export const REGION_NAME_ALIASES = {
  'valle-aosta': 'valle-aosta',
  valledaosta: 'valle-aosta',
  valle_d_aosta: 'valle-aosta',
  region_valle_aosta: 'valle-aosta',
  piemonte: 'piemonte',
  region_piemonte: 'piemonte',
  liguria: 'liguria',
  region_liguria: 'liguria',
  lombardia: 'lombardia',
  region_lombardia: 'lombardia',
  trentino: 'trentino',
  trentino_alto_adige: 'trentino',
  region_trentino: 'trentino',
  veneto: 'veneto',
  region_veneto: 'veneto',
  friuli: 'friuli',
  'friuli-vg': 'friuli',
  friuli_venezia_giulia: 'friuli',
  region_friuli: 'friuli',
  emilia: 'emilia',
  'emilia-romagna': 'emilia',
  emilia_romagna: 'emilia',
  region_emilia: 'emilia',
  toscana: 'toscana',
  region_toscana: 'toscana',
  umbria: 'umbria',
  region_umbria: 'umbria',
  marche: 'marche',
  region_marche: 'marche',
  lazio: 'lazio',
  region_lazio: 'lazio',
  abruzzo: 'abruzzo',
  region_abruzzo: 'abruzzo',
  molise: 'molise',
  region_molise: 'molise',
  campania: 'campania',
  region_campania: 'campania',
  puglia: 'puglia',
  region_puglia: 'puglia',
  basilicata: 'basilicata',
  region_basilicata: 'basilicata',
  calabria: 'calabria',
  region_calabria: 'calabria',
  sicilia: 'sicilia',
  region_sicilia: 'sicilia',
  sardegna: 'sardegna',
  region_sardegna: 'sardegna',
};

/** Colori base per macro-zona (hex → three color) */
export function macroColor(macro) {
  return MACRO_ZONE[macro]?.color || '#c78244';
}

export function regionMacroOf(regionId) {
  return REGION_MACRO[regionId] || 'centro';
}

/** Rotazione per cartina verticale (GLB esportato orizzontale su piano XZ) */
export const MAP_STAND_ROTATION = [Math.PI / 2, 0, 0];

/**
 * Preset camera — cartina in piedi, vista frontale da +Z.
 * position: [x, y, z], target: punto di focus
 */
export const MACRO_CAMERA = {
  full:   { position: [0, 0, 11], target: [0, 0, 0], fov: 40 },
  nord:   { position: [0, 2.2, 10], target: [0, 2, 0], fov: 38 },
  centro: { position: [0, 0, 10], target: [0, 0, 0], fov: 40 },
  sud:    { position: [0, -2.5, 10], target: [0, -2.2, 0], fov: 38 },
  isole:  { position: [1.8, -3.8, 10], target: [1.2, -3.2, 0], fov: 36 },
};

export const REGION_LABELS = {
  'valle-aosta': "Valle d'Aosta",
  piemonte: 'Piemonte',
  liguria: 'Liguria',
  lombardia: 'Lombardia',
  trentino: 'Trentino',
  veneto: 'Veneto',
  friuli: 'Friuli-V.G.',
  emilia: 'Emilia-Romagna',
  toscana: 'Toscana',
  umbria: 'Umbria',
  marche: 'Marche',
  lazio: 'Lazio',
  abruzzo: 'Abruzzo',
  molise: 'Molise',
  campania: 'Campania',
  puglia: 'Puglia',
  basilicata: 'Basilicata',
  calabria: 'Calabria',
  sicilia: 'Sicilia',
  sardegna: 'Sardegna',
};
